
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data: function () {
    return {
      isPage: typeof this.$route.query.type !== 'undefined' && this.$route.query.type == 'page',
      tournament: null,
      timer: {
        distance: null,
        interval: null
      },
      prizes: null,
      prizes_details: null,
      viewPrizesDetails: false
    };
  },
  methods: {
    toProfileDetails(id) {
      console.log(id);
      this.$router.navigate({
        name: 'profile-details',
        query: { 'id': id }
      });
    },
    handlerPrizes(tournament) {
      let result = [];
      if (!!tournament.for_points) {
        let prizes = tournament.prizesV2;
        for (let i = 0; i < prizes.length; i++) {
          let {
            place_from,
            place_to,
            amount: {value, percent}
          } = prizes[i];
          if (typeof value === 'number') {
            if (typeof percent === 'object' && !!percent === false) {
              result.push({
                'amount': {
                  'value': value,
                  'currency': '<i class="fas fa-star"></i>'
                },
                'place_from': place_from,
                'place_to': place_to
              });
            } else {
              result.push({
                'amount': {
                  'value': percent + ' % (' + value,
                  'currency': '<i class="fas fa-star"></i>)'
                },
                'place_from': place_from,
                'place_to': place_to
              });
            }
          } else {
            if (typeof percent === 'number' && !!percent === true) {
              result.push({
                'amount': {
                  'value': percent,
                  'currency': '%'
                },
                'place_from': place_from,
                'place_to': place_to
              });
            }
          }
        }
      } else {
        let prizes = tournament.prizesV2;
        for (let i = 0; i < prizes.length; i++) {
          let {
            place_from,
            place_to,
            amount: {currency, value, percent}
          } = prizes[i];
          if (typeof value === 'number') {
            if (typeof percent === 'object' && !!percent === false) {
              result.push({
                'amount': {
                  'value': value,
                  'currency': currency
                },
                'place_from': place_from,
                'place_to': place_to
              });
            } else {
              result.push({
                'amount': {
                  'value': percent + ' % (' + value,
                  'currency': currency + ')'
                },
                'place_from': place_from,
                'place_to': place_to
              });
            }
          } else {
            if (typeof percent === 'number' && !!percent === true) {
              result.push({
                'amount': {
                  'value': percent,
                  'currency': '%'
                },
                'place_from': place_from,
                'place_to': place_to
              });
            }
          }
        }
      }
      return result;
    },
    handlerPrizesDetails(tournament) {
      let result = [];
      if (!!tournament.for_points) {
        let prizes = tournament.prizesV2;
        for (let i = 0; i < prizes.length; i++) {
          let {
            place_from,
            place_to,
            amount: {value, percent}
          } = prizes[i];
          if (typeof value === 'number') {
            if (typeof percent === 'object' && !!percent === false) {
              if (place_from == place_to) {
                result.push({
                  'amount': {
                    'value': value,
                    'currency': '<i class="fas fa-star"></i>'
                  },
                  'place_from': place_from,
                  'place_to': place_to
                });
              }
              if (place_from < place_to) {
                let count = place_to - place_from + 1;
                let summ = Math.round(value / count);
                let place = place_from;
                while (place <= place_to) {
                  result.push({
                    'amount': {
                      'value': summ,
                      'currency': '<i class="fas fa-star"></i>'
                    },
                    'place_from': place,
                    'place_to': ''
                  });
                  place++;
                }
              }
            } else {
              if (place_from === place_to) {
                if (this.viewPrizesDetails === false) {
                  result.push({
                    'amount': {
                      'value': value,
                      'currency': '<i class="fas fa-star"></i>'
                    },
                    'place_from': place_from,
                    'place_to': place_to
                  });
                } else {
                  result.push({
                    'amount': {
                      'value': value,
                      'currency': '<i class="fas fa-star"></i>'
                    },
                    'place_from': place_from,
                    'place_to': place_to
                  });
                }
              }
              if (place_from < place_to) {
                let count = place_to - place_from + 1;
                let summ = Math.round(value / count);
                let place = place_from;
                while (place <= place_to) {
                  result.push({
                    'amount': {
                      'value': summ,
                      'currency': '<i class="fas fa-star"></i>'
                    },
                    'place_from': place,
                    'place_to': ''
                  });
                  place++;
                }
              }
            }
          } else {
            if (typeof percent === 'number' && !!percent === true) {
              result.push({
                'amount': {
                  'value': percent,
                  'currency': '%'
                },
                'place_from': place_from,
                'place_to': place_to
              });
            }
          }
        }
      } else {
        let prizes = tournament.prizesV2;
        for (let i = 0; i < prizes.length; i++) {
          let {
            place_from,
            place_to,
            amount: {currency, value, percent}
          } = prizes[i];
          if (typeof value === 'number') {
            if (typeof percent === 'object' && !!percent === false) {
              if (place_from === place_to) {
                result.push({
                  'amount': {
                    'value': value,
                    'currency': currency
                  },
                  'place_from': place_from,
                  'place_to': ''
                });
              }
              if (place_from < place_to) {
                let count = place_to - place_from + 1;
                let summ = Math.round(value / count);
                let place = place_from;
                while (place <= place_to) {
                  result.push({
                    'amount': {
                      'value': summ,
                      'currency': currency
                    },
                    'place_from': place,
                    'place_to': ''
                  });
                  place++;
                }
              }
            } else {
              if (place_from === place_to) {
                if (this.viewPrizesDetails === false) {
                  result.push({
                    'amount': {
                      'value': percent + ' % (' + value,
                      'currency': currency + ')'
                    },
                    'place_from': place_from,
                    'place_to': ''
                  });
                } else {
                  result.push({
                    'amount': {
                      'value': value,
                      'currency': currency
                    },
                    'place_from': place_from,
                    'place_to': ''
                  });
                }
              }
              if (place_from < place_to) {
                let count = place_to - place_from + 1;
                let summ = Math.round(value / count);
                let place = place_from;
                while (place <= place_to) {
                  result.push({
                    'amount': {
                      'value': summ,
                      'currency': currency
                    },
                    'place_from': place,
                    'place_to': ''
                  });
                  place++;
                }
              }
            }
          } else {
            if (typeof percent === 'number' && !!percent === true) {
              if (place_from === place_to) {
                result.push({
                  'amount': {
                    'value': percent,
                    'currency': '%'
                  },
                  'place_from': place_from,
                  'place_to': place_to
                });
              }
            }
          }
        }
      }
      console.log(result);
      return result;
    },
    checkViewPrizesDetails(tournament) {
      let view = false;
      let prizes = tournament.prizes;
      for (var i = 0; i < prizes.length; i++) {
        let {place_from, place_to} = prizes[i];
        if (place_from < place_to) {
          view = true;
        }
      }
      return view;
    },
    ruleInfo: function (title, description) {
      this.$app.dialog.alert(description, title);
    },
    close: function () {
      this.$app.popup.close();
    },
    updateTimer: function () {
      var hours = Math.floor(this.timer.distance / (1000 * 60 * 60));
      var minutes = Math.floor(this.timer.distance % (1000 * 60 * 60) / (1000 * 60));
      var seconds = Math.floor(this.timer.distance % (1000 * 60) / 1000);
      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;
      this.$el.find('#timer').html(hours + ':' + minutes + ':' + seconds);
      this.timer.distance -= 1000;
      if (this.timer.distance < 0) {
        clearInterval(this.timer.interval);
      }
    }
  },
  on: {
    pageInit: function () {
      var self = this;
      let url = 'app/tournaments/';
      if (self.$root.isNosession()) {
        url = 'app/public/tournaments/';
      }
      this.$root.api(url + self.$route.params.id, {}, 'GET', function (data, status, xhr) {
        if (data.status == 'error') {
          self.$app.dialog.alert(data.message, 'Ошибка');
        }
        if (data.status == 'ok') {
          let viewPrizesDetails = self.checkViewPrizesDetails(data.tournament);
          let prizes = self.handlerPrizes(data.tournament);
          let prizes_details = self.handlerPrizesDetails(data.tournament);
          self.$setState({
            tournament: data.tournament,
            prizes,
            prizes_details,
            viewPrizesDetails
          });
          if (data.tournament.status == 'open') {
            var timeStarted = new Date(data.tournament.call_for_before);
            var timeCurrent = new Date();
            self.timer.distance = timeStarted.getTime() - timeCurrent.getTime();
            self.updateTimer();
            self.timer.interval = setInterval(function () {
              self.updateTimer();
            }, 1000);
          } else {
            clearInterval(self.timer.interval);
          }
        }
      }, true);
    },
    pageBeforeRemove: function () {
      if (this.timer.interval !== null) {
        clearInterval(this.timer.interval);
      }
    }
  },
  id: '68f85e6e31',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page">\n        <div class="navbar">\n            <div class="navbar-inner navbar-popup">\n                <div class="left">\n                    ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.isPage, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <a href="#" class="link back icon-only">\n                            <i class="icon icon-back"></i>\n                        </a>\n                    ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <a href="#" class="link" @click="close">Закрыть</a>\n                    ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                </div>\n                <div class="title">Детали турнира</div>\n                <div class="subnavbar md subnavbar-menu tour-info-subnavbar">\n                    ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.tournament, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.tournament, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                            <div class="tour-info-top">\n                                <div class="tour-info-top-first">\n                                     ';
              r += c(ctx_3.title, ctx_3);
              r += '</div>\n                                <div class="tour-info-top-second">\n                                    <div class="tour-info-top-second-col">\n                                        <div class="tour-info-top-col-top">\n                                            ';
              r += c(ctx_3.participants.current, ctx_3);
              r += '&nbsp;\n                                            ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.participants.percent==\'100\'', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                            <i class="icon icon-progress-complete"></i>\n                                            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                                        </div>\n                                        <div class="tour-info-top-col-bottom">участники</div>\n                                    </div>\n                                    <div class="tour-info-top-second-col">\n                                        <div class="tour-info-top-col-top">';
              r += Template7Helpers.formatPrice.call(ctx_3, ctx_3.ingress.value, {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += ' ';
              r += c(ctx_3.ingress.currency, ctx_3);
              r += '</div>\n                                        <div class="tour-info-top-col-bottom text-align-center">вход</div>\n                                    </div>\n                                    <div class="tour-info-top-second-col">\n                                        <div class="tour-info-top-col-top">\n                                            ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.prize.message, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                                TBD\n                                            ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                                ';
                  r += Template7Helpers.formatPrice.call(ctx_4, ctx_4.prize.value, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += ' ';
                  r += c(ctx_4.prize.currency, ctx_4);
                  r += '\n                                            ';
                  return r;
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                                        </div>\n                                        <div class="tour-info-top-col-bottom text-align-right">приз</div>\n                                    </div>\n                                </div>\n                                <div class="tour-info-top-third">\n                                    <div class="tour-info-top-bottom-left">\n                                        <i class="icon icon-sport-ucl"></i>\n                                            ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.status == \'open\' || this.status == \'nomorebets\'', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                                ';
                  r += Template7Helpers.formatDate.call(ctx_4, ctx_4.started_at, {
                    hash: { 'type': 'full' },
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                            ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                                ';
                  r += Template7Helpers.formatDate.call(ctx_4, ctx_4.started_at, {
                    hash: { 'type': 'date' },
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                            ';
                  return r;
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                                    </div>\n                                    <div class="tour-info-top-bottom-right" id="timer">\n                                        ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.status == \'finished\'', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                            <span class="tour-info-ended-title">завершено</span>\n                                        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                                        ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.status == \'canceled\'', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                            <span class="tour-info-ended-title">отменено</span>\n                                        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                                        ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.status == \'open\' || this.status == \'nomorebets\'', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n\n                                        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="subnavbar-inner ios" style="height: 60px;">\n                                <div class="segmented">\n                                    <a class="button tab-link" href="#tab-tour-rules">Правила</a>\n                                    <a class="button tab-link" href="#tab-tour-cup">Призы</a>\n                                    ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.status == \'open\' || this.status == \'nomorebets\'', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                        <a class="button tab-link tab-link-active" href="#tab-tour-games">Игры</a>\n                                        <a class="button tab-link" href="#tab-tour-gamers">Входы</a>\n                                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                                </div>\n                            </div>\n                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                </div>\n            </div>\n        </div>\n        <div class="page-content" style="padding-top: 188px;">\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.tournament, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div class="tabs">\n                    <div class="tab" id="tab-tour-rules">\n                        <div class="block block-strong mt-0 pt-1">\n                            <div class="main-svg">\n                                <img src="./static/icons/main-tournament.svg" alt="">\n                            </div>\n                            <div class="block-header">Правила</div>\n                            <div class="list-tour-rules">\n                                <ul>\n                                    <li>\n                                        <div class="item-inner">\n                                            <div class="item-media">\n                                                <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                                    <path d="M13.27 0.151367L5.0319 8.38941L0.729983 4.08756L0 4.81754L5.0319 9.84937L14 0.88135L13.27 0.151367Z" fill="#32BF61"/>\n                                                </svg>\n                                            </div>\n                                            <a href="">Выбери свою команду из <strong>8</strong> футболистов</a>\n                                        </div>\n                                    </li>\n                                    <li>\n                                        <div class="item-inner">\n                                            <div class="item-media">\n                                                <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                                    <path d="M13.27 0.151367L5.0319 8.38941L0.729983 4.08756L0 4.81754L5.0319 9.84937L14 0.88135L13.27 0.151367Z" fill="#32BF61"/>\n                                                </svg>\n                                            </div>\n                                            <a href="">У всех игроков есть зарплата, а у тебя бюджет <br><strong>$60 000</strong></a>\n                                        </div>\n                                    </li>\n                                    <li>\n                                        <div class="item-inner">\n                                            <div class="item-media">\n                                                <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                                    <path d="M13.27 0.151367L5.0319 8.38941L0.729983 4.08756L0 4.81754L5.0319 9.84937L14 0.88135L13.27 0.151367Z" fill="#32BF61"/>\n                                                </svg>\n                                            </div>\n                                            <a href="">В некоторые турниры можно войти несколько раз с разными командами</a>\n                                        </div>\n                                    </li>\n                                    <li>\n                                        <div class="item-inner">\n                                            <div class="item-media">\n                                                <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                                    <path d="M13.27 0.151367L5.0319 8.38941L0.729983 4.08756L0 4.81754L5.0319 9.84937L14 0.88135L13.27 0.151367Z" fill="#32BF61"/>\n                                                </svg>\n                                            </div>\n                                            <a href="">За каждое действие твоего футболиста в реальном матче начисляются очки</a>\n                                        </div>\n                                    </li>\n                                    <li>\n                                        <div class="item-inner">\n                                            <div class="item-media">\n                                                <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                                    <path d="M13.27 0.151367L5.0319 8.38941L0.729983 4.08756L0 4.81754L5.0319 9.84937L14 0.88135L13.27 0.151367Z" fill="#32BF61"/>\n                                                </svg>\n                                            </div>\n                                            <a href="">В зависимости от суммы набранных очков распределяются призовые места</a>\n                                        </div>\n                                    </li>\n                                    <li>\n                                        <div class="item-inner" style="padding-top: 15px;">\n                                            <div class="item-media">\n                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                                    <circle cx="6" cy="6" r="4.75" fill="#FFCB0A" stroke="white" stroke-width="1.5"/>\n                                                </svg>\n                                            </div>\n                                            <a href="">Игрок ожидается в основном составе</a>\n                                        </div>\n                                    </li>\n                                    <li>\n                                        <div class="item-inner">\n                                            <div class="item-media">\n                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                                    <circle cx="6" cy="6" r="4.75" fill="#32BF61" stroke="white" stroke-width="1.5"/>\n                                                </svg>\n                                            </div>\n                                            <a href="">Игрок вышел на поле</a>\n                                        </div>\n                                    </li>\n                                    <li>\n                                        <div class="item-inner">\n                                            <div class="item-media">\n                                                <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                                    <path d="M8.24974 11C8.0162 11 7.82666 10.81 7.82666 10.5769V0.423077C7.82666 0.189962 8.0162 0 8.24974 0H10.3651C10.5982 0 10.7882 0.189962 10.7882 0.423077V10.5769C10.7882 10.81 10.5982 11 10.3651 11H8.24974Z" fill="#C4C4C4"/>\n                                                    <path d="M4.44212 10.9996C4.20858 10.9996 4.01904 10.8097 4.01904 10.5765V2.96116C4.01904 2.72805 4.20858 2.53809 4.44212 2.53809H6.55751C6.79062 2.53809 6.98058 2.72805 6.98058 2.96116V10.5765C6.98058 10.8097 6.79062 10.9996 6.55751 10.9996H4.44212Z" fill="#C4C4C4"/>\n                                                    <path d="M0.634503 11.0002C0.400964 11.0002 0.211426 10.8103 0.211426 10.5771V5.50023C0.211426 5.26711 0.400964 5.07715 0.634503 5.07715H2.74989C2.983 5.07715 3.17296 5.26711 3.17296 5.50023V10.5771C3.17296 10.8103 2.983 11.0002 2.74989 11.0002H0.634503Z" fill="#C4C4C4"/>\n                                                </svg>\n                                            </div>\n                                            <a href="">По игроку есть статистика</a>\n                                        </div>\n                                    </li>\n                                </ul>\n                            </div>\n                            <!--<div class="block-header">Примечание</div>\n                            <div class="list-tour-rules">\n                                <ul>\n                                    <li>\n                                        <div class="item-inner pb-0">\n                                            <a href="" class="pl-0">Трехочковый гол на поле награждается 1FG и 3P</a>\n                                        </div>\n                                    </li>\n                                </ul>\n                            </div>-->\n                        </div>\n                        ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.tournament.rules, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                            <div class="block tour-info-block">';
              r += Template7Helpers.escape.call(ctx_3, ctx_3.name, {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '</div>\n                            <div class="list tour-info-list-rules">\n                                <ul>\n                                    ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.rules, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                        <li class="item-content">\n                                            <div class="item-media">\n                                                <a href="#" @click="ruleInfo(\'';
                  r += Template7Helpers.escape.call(ctx_4, ctx_4.name, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\', \'';
                  r += Template7Helpers.escape.call(ctx_4, ctx_4.description, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\')" class="link icon-only"><i class="f7-icons">info_circle</i></a>\n                                            </div>\n                                            <div class="item-inner">\n                                                <div class="item-title">\n                                                    ';
                  r += Template7Helpers.escape.call(ctx_4, ctx_4.abbr, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += ' <span class="rule-full">(';
                  r += Template7Helpers.escape.call(ctx_4, ctx_4.abbr_full, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += ')</span>\n                                                    <div class="item-footer">';
                  r += Template7Helpers.escape.call(ctx_4, ctx_4.name, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '</div>\n                                                </div>\n                                                <div class="item-after">\n                                                    <span class="points-main';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.points < 0', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += ' points-negative';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '">';
                  r += Template7Helpers.js.call(ctx_4, 'this.points.toString().split(\'.\')[0]', {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '</span>\n                                                    ';
                  r += Template7Helpers.js_if.call(ctx_4, 'typeof this.points.toString().split(\'.\')[1] !== \'undefined\'', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                                        <span class="points-add';
                      r += Template7Helpers.js_if.call(ctx_5, 'this.points < 0', {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += ' points-negative';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '">.';
                      r += Template7Helpers.js.call(ctx_5, 'this.points.toString().split(\'.\')[1]', {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '</span>\n                                                    ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                                </div>\n                                            </div>\n                                        </li>\n                                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                                </ul>\n                            </div>\n                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                    </div>\n                        <div class="tab" id="tab-tour-cup">\n                            ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.viewPrizesDetails === true', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                <div class="list tour-info-list-cup mt-0">\n                                    <ul>\n                                        ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.prizes, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                            <li class="item-content">\n                                                <div class="item-inner">\n                                                    <div class="item-title width-100 tour-info-cup-li-item">\n                                                        <span class="tour-info-cup-li-item-top">';
                  r += c(ctx_4.place_from, ctx_4);
                  r += '-';
                  r += c(ctx_4.place_to, ctx_4);
                  r += '</span>\n                                                        <span class="tour-info-cup-li-item-top">';
                  r += c(ctx_4.amount.value, ctx_4);
                  r += ' ';
                  r += c(ctx_4.amount.currency, ctx_4);
                  r += '</span>\n                                                    </div>\n                                                </div>\n                                            </li>\n                                        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                                    </ul>\n                                </div>\n                            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                        <div class="list tour-info-list-cup-details mt-0">\n                            <ul>\n                                ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.prizes_details, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                    <li class="item-content">\n                                        <div class="item-inner">\n                                            <div class="item-title width-100 tour-info-cup-li-item">\n                                                <span class="tour-info-cup-li-item-top">';
              r += c(ctx_3.place_from, ctx_3);
              r += '</span>\n                                                <span class="tour-info-cup-li-item-top">';
              r += c(ctx_3.amount.value, ctx_3);
              r += ' ';
              r += c(ctx_3.amount.currency, ctx_3);
              r += '</span>\n                                            </div>\n                                        </div>\n                                    </li>\n                                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                            </ul>\n                        </div>\n                    </div>\n                    ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.tournament.status == \'open\' || this.tournament.status == \'nomorebets\'', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <div class="tab tab-active" id="tab-tour-games">\n                            <div class="list list-games no-chevron mt-0">\n                                <ul>\n                                    ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.tournament.matches, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                        <li class="item-content justify-content-space-between align-items-center">\n                                            <div class="item-inner">\n                                                <div class="game-games-left ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.is_finished && this.localteam_goals > this.visitorteam_goals ', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += 'text-bold';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '">\n                                                    ';
                  r += Template7Helpers.escape.call(ctx_4, ctx_4.localteam, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                                </div>\n                                                <div class="game-games-center">\n                                                    <div class="game-games-center-top text-align-center">\n                                                        ';
                  r += Template7Helpers.formatDate.call(ctx_4, ctx_4.started_at, {
                    hash: { 'type': 'date' },
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                                    </div>\n                                                    <div class="game-games-center-top">\n                                                        ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.localteam_goals, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                                            <span class="game-games-scores text-align-center">';
                      r += c(ctx_5.localteam_goals, ctx_5);
                      r += '</span>\n                                                            <span class="game-games-scores text-align-center">:</span>\n                                                            <span class="game-games-scores text-align-center">';
                      r += c(ctx_5.visitorteam_goals, ctx_5);
                      r += '</span>\n                                                        ';
                      return r;
                    },
                    inverse: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                                            <span class="game-games-scores text-align-center">-</span>\n                                                        ';
                      return r;
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                                    </div>\n                                                    <div class="game-games-center-bottom text-align-center">\n                                                        ';
                  r += Template7Helpers.escape.call(ctx_4, ctx_4.current_state, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                                    </div>\n                                                </div>\n                                                <div class="game-games-right ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.is_finished && this.localteam_goals < this.visitorteam_goals ', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += 'text-bold';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '">\n                                                    ';
                  r += Template7Helpers.escape.call(ctx_4, ctx_4.visitorteam, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                                </div>\n                                            </div>\n                                        </li>\n                                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                                </ul>\n                            </div>\n                        </div>\n                        <div class="tab" id="tab-tour-gamers">\n                            <div class="list no-chevron mt-0">\n                                <ul>\n                                    ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.tournament.participants.list, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                        <li class="game-player tour-info-game-player item-content ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.place, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += 'player-with-place';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '" id="';
                  r += c(ctx_4.prefix, ctx_4);
                  r += '-';
                  r += c(ctx_4.id, ctx_4);
                  r += '">\n                                            ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.place, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                                <div class="item-media text-align-center justify-content-center">\n                                                    ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.is_prize, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                                        <span class="game-player-place-cup';
                          r += Template7Helpers.if.call(ctx_6, ctx_6.is_self, {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '-i';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '"><span>';
                          r += c(ctx_6.place, ctx_6);
                          r += '</span></span>\n                                                    ';
                          r += Template7Helpers.if.call(ctx_6, ctx_6.is_self, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                                        <span class="game-player-place';
                          r += Template7Helpers.if.call(ctx_6, ctx_6.is_self, {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '-i';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '"><span>';
                          r += c(ctx_6.place, ctx_6);
                          r += '</span></span>\n                                                    ';
                          return r;
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                                                </div>\n                                            ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                            <div @click="toProfileDetails(';
                  r += c(ctx_4.id, ctx_4);
                  r += ')" class="item-inner justify-content-start">\n                                                <img class="game-player-avatar" src="';
                  r += c(ctx_4.avatar, ctx_4);
                  r += '">\n                                                <div class="item-title">\n                                                    <span class="game-player-name';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.is_self, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '-i';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '">';
                  r += Template7Helpers.escape.call(ctx_4, ctx_4.name, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '</span>\n                                                </div>\n                                            </div>\n                                        </li>\n                                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                                </ul>\n                            </div>\n                        </div>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                </div>\n            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div class="block block-strong text-align-center">\n                    <div class="preloader"></div>\n                </div>\n            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  style: `
    .tour-info-list-cup + .tour-info-list-cup-details {
        margin-top: 35px !important;
    }
    .points-negative{
        color: #BE2D33 !important;
    }
    .rule-full {
        color: #AAADB3;
    }
    .game-games-center{
        margin-left: 10px;
        margin-right: 10px;
        width:36%;
    }
    .game-games-center-top{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .list-games .item-content{
        padding-left:  calc(10px + var(--f7-safe-area-left));
        padding-right: calc(10px + var(--f7-safe-area-left));
    }

    .game-games-center-top{
        position: relative;
        /*top: 5px;*/
        font-size: 11px;
        text-align: center;
        color: #99A8B1;
    }

    .game-games-center-bottom{
        position: relative;
        /*top: -5px;*/
        font-size: 11px;
        text-align: center;
        color: #99A8B1;
    }

    .game-games-scores{
        width: 28px;
        font-size: 26px;
        font-weight: bold;
        text-transform: uppercase;
        color: #445058;
    }
    .game-games-left{
        width:33%;
        font-size: 16px;
        text-align: center;
        color: #445058;
        line-height: 18px;
    }
    .game-games-right{
        width:33%;
        font-size: 16px;
        text-align: center;
        color: #445058;
        line-height: 18px;
    }

    .tour-info-ended-title{
        font-size: 14px;
        text-transform: uppercase;
        color: #BE2D33;
    }
    .tour-info-subnavbar{
        height: 145px !important;
        flex-direction: column;
    }
    .tour-info-cup-li-item{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .tour-info-cup-li-item-top{
        font-weight:500;
        font-size: 17px;
        color: #445058;
        display: inline-flex;
        align-items: center;
    }
    .tour-info-cup-li-item-top{
        font-size: 17px;
        color: #445058;
    }

    .tour-info-games-block-command-div>span{
        position: relative;
        top: 3px;
    }



    .player-with-place{
        padding-left: var(--f7-safe-area-left) !important;
    }
    .tour-info-block{
        font-size: 12px;
        font-weight: 500;
        color: #445058;

    }
    .tour-info-list-rules .item-after{
       align-items: baseline;;
    }
    .tour-info-list-rules .item-title{
        font-size: 16px;
        font-weight: 500;
        color: #445058;
    }
    .tour-info-list-rules .item-footer{
        font-size: 12px;
        font-weight: 500;
        color: #AAADB3;
    }
    .tour-info-list-rules .item-after .points-main{
        font-size: 24px;
        color: #32BF61;
    }
    .tour-info-list-rules .item-after .points-add{
        font-size: 19px;
        color: #32BF61;
    }

    .tour-info-top{
        width: calc(100% - 26px);
        height: 108px;
        flex-direction: column;
        display: flex;
    }
    .tour-info-top-first{
        margin-top: 4px;
        font-weight:bold;
        color: #007AFF;
        font-size: 15px;
        white-space: nowrap;
        height: 1.2em;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .tour-info-top-second{
        margin-top: 4px;
        flex-direction: row;
        display: flex;
        justify-content: space-between;
    }
    .tour-info-top-second-col{
        flex-direction: column;
        display: flex;
    }
    .tour-info-top-third{
        border-top: 1px solid #c8c7cc;
        padding-top: 6px;
        margin-top: 4px;
        flex-direction: row;
        display: flex;
        justify-content: space-between;
    }

    .tour-info-top-bottom-left{
        flex-direction: row;
        display: flex;
        font-size: 14px;
        color: #445058;
    }
    .tour-info-top-bottom-left i{
        margin-top: 1px;
        padding-left: 0;
        margin-right: 6px
    }

    .tour-info-top-bottom-right{
        font-size: 14px;
        line-height: 22px;
        text-align: right;
        font-weight: bold;
        color: #445058;
    }

    .tour-info-top-col-top{
        font-size: 14px;
        line-height: 16px;
        color: #445058;
        font-weight: 500;
        display: inline-flex;
        align-items: center;
    }
    /* .tour-info-top-col-top .icon{
        position: relative;
        top: -1px;
        margin-right: 5px;
        margin-bottom: 0px;
    } */
    .tour-info-top-col-bottom{
        font-size: 10px;
        line-height: 16px;
        text-transform: uppercase;
        color: #818E95;
    }

    #tab-tour-rules .main-svg {
        text-align: center;
    }

    #tab-tour-rules .main-svg img {
        display: block;
        max-width: 420px;
        margin: 0 auto;
    }

    #tab-tour-rules .block-header {
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.35px;
        text-transform: uppercase;
        margin-bottom: 2px;
        margin-top: 12px;
    }

    .list-tour-rules > ul {
        padding-left: 0;
        margin: 0;
    }

    .list-tour-rules > ul > li {
        list-style-type: none;
    }

    .list-tour-rules > ul > li > .item-inner {
        padding-top: 5px;
        padding-bottom: 5px;
        display: flex;
    }

    .list-tour-rules > ul > li > .item-inner > a {
        pointer-events: none;
        cursor: default;
        color: #445058;
        font-size: 14px;
        line-height: 17px;
        padding-left: 12px;
    }

    .list-tour-rules > ul > li > .item-inner > .item-media {
        display: flex;
        flex-direction: column;
        margin-top: .3em;
        justify-content: start;
    }

`,
  styleScoped: false
};
    